module.exports = __webpack_public_path__ + "static/media/terms.9cffcad6.xhtml";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/shared/ModalTerms/terms.xhtml
// module id = 321
// module chunks = 37